// extracted by mini-css-extract-plugin
export default {"jobDetailedInfo":"JobDetailedInfo_jobDetailedInfo__Yn1f5"};